import gql from "graphql-tag";

export const PUBLIC_UPDATE_RETIREMENT_CALCULATOR = gql`
  mutation updatePublicRetirementCalc($input: RetirementCalcInput) {
    updatePublicRetirementCalc(input: $input) {
      currentAge
      retirementAge
      yearsLeftInRetirement
      yearsInRetirement
      lifeStyleCostBeforeRetirement
      currentPortfolio
      annualContributions
      returnRateBeforeRetirement
      returnRateAfterRetirement
      inflationRate
      accountSizeAtRetirement
      lifeStyleCostAfterRetirement
      runOutOfMoneyAtAge
      willRunOutOfMoney
    }
  }
`;

export const CLICK_BANNER = gql`
  mutation ClickBanner($bannerId: ID) {
    clickBanner(bannerId: $bannerId)
  }
`;
